export default "__VITE_ASSET__D6$g_XXr__"